import React, { useState, useEffect } from "react";
import ButtonSpinner from "../../ButtonSpinner";
// ...existing code...
import API_URL from '../../../utils/api';
import useCreateSession from "../Controller/useCreateSession.controller";
import useIntelliMeMatch from "../../IntelliMe/Controller/useIntelliMeMatch";
import "../../Dashboard/View/Dashboard.css";
export default function CreateSession({ user, onClose }) {
  const [sessionName, setSessionName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const { handleCreateSession } = useCreateSession({
    user,
    setError,
    setSuccess,
    setLoading,
    setSessionName
  });
  const { joinQueue } = useIntelliMeMatch();
  useEffect(() => {
    setSessionName("");
    setError("");
    setSuccess("");
    setLoading(false);
  }, []);
  // Only call onClose after a successful create, and clear success to prevent loop
  useEffect(() => {
    if (success && onClose) {
      const timer = setTimeout(() => {
        onClose();
        setSuccess("");
      }, 1200);
      return () => clearTimeout(timer);
    }
  }, [success, onClose, setSuccess]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);
    try {
      const created = await handleCreateSession(sessionName);

      const createdSessionId = created?.id ?? created?.sessionId ?? created?.session_id;
      const createdSessionName = created?.name ?? sessionName;

      if (createdSessionId) {
        await joinQueue(createdSessionId, user, createdSessionName);
      } else {
        // handleCreateSession may not return the session, so fetch sessions and find the latest
        const res = await fetch(`${API_URL}/api/sessions`);
        const sessions = await res.json();
        const mySession = sessions.find(s => s.name === sessionName && (s.host === user.name || s.host_id === user.id || s.host_id === user.uid));
        if (mySession) {
          await joinQueue(mySession.id || mySession.sessionId, user, mySession.name);
        }
      }
    } catch (err) {
      setError("Failed to create and join queue");
    }
    setLoading(false);
  };
  return (
    <div className="dashboard-section dashboard-create-session">
      <h3>Create Session</h3>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Session Name"
          value={sessionName}
          onChange={e => setSessionName(e.target.value)}
          className="dashboard-input"
        />
        <button
          className="dashboard-btn"
          type="submit"
          disabled={loading}
        >
          {loading ? <ButtonSpinner /> : "Create Session"}
        </button>
      </form>
      {error && <div className="dashboard-error">{error}</div>}
      {success && <div className="dashboard-success">{success}</div>}
    </div>
  );
}
